// src/components/LoginForm.tsx
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import useInscrito from "../../core/hooks/useInscrito";
import DefaultLayout from "../layouts/default/Default.layout";
import Quizz from "../components/Quizz/Quizz";

export default function ResultadoSimulado() {
  const {fetchInscrito, fetchResolucoes, inscrito, resolucoes} = useInscrito();
  const {registeredID} = useParams();

  useEffect(()=>{
    const load = async () =>{
      fetchInscrito(registeredID as string);
      fetchResolucoes(registeredID as string);
    }
    load();
  },[fetchInscrito, fetchResolucoes]);  

  return (
    <DefaultLayout>
      {inscrito.mocktest?.situation !== 'finalizado' && <div className="text-lg font-semibold max-w-[80%] mx-auto p-4 bg-white dark:bg-gray-900 shadow-md rounded-2xl text-orange-500 w-full sm:w-[90%] mb-2 px-10 ">
        <p>Simulado ainda não finalizado. Aguarde para ver a sua classificação no rank e o gabarito do simulado.</p>
      </div>}
      <div className="text-lg font-semibold max-w-[80%] mx-auto p-4 bg-white dark:bg-gray-900 shadow-md rounded-2xl flex flex-row justify-between w-full sm:w-[90%] mb-6 px-10 ">
        <p>{inscrito.mocktest?.description}</p>
        {inscrito.mocktest?.situation === 'finalizado' && <div className="flex flex-row gap-2">
          Rank:
          <p className="text-blue-600">{inscrito.rank}º Lugar</p>
        </div>}
        {inscrito.mocktest?.situation === 'finalizado' && <div className="flex flex-row gap-2">
          Acertos:
          <p>{inscrito.total_correct}/{resolucoes?.length}</p>
        </div>}
        <p>{inscrito.mocktest?.situation}</p>
      </div>
      <div className="flex flex-col gap-6 h-[80vh] overflow-auto">
        {
          resolucoes?.map(item => 
            <Quizz questionReceived={item} showResolution={inscrito.mocktest?.situation === 'finalizado' ?true:false}/>
          ) 
        }
      </div>
    </DefaultLayout>  
  );
}
